import * as React from 'react';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import ContentCut from '@mui/icons-material/ContentCut';
import ContentCopy from '@mui/icons-material/ContentCopy';
import ContentPaste from '@mui/icons-material/ContentPaste';
import View from '@mui/icons-material/Visibility';
import Edit from '@mui/icons-material/Edit';
import Delete from '@mui/icons-material/Delete';
import Cloud from '@mui/icons-material/Cloud';

export default function IconMenu(props) {

  console.log(props)


  return (
    <Paper sx={{ width: 320, maxWidth: '100%' }}>
      <MenuList>
        <MenuItem onClick={props.view}>
          <ListItemIcon>
            <View fontSize="small" />
          </ListItemIcon>
          <ListItemText>View</ListItemText>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {/* ⌘X */}
          </Typography>
        </MenuItem>
      
      
        <MenuItem onClick={props.approve}>
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          <ListItemText>Approve</ListItemText>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {/* ⌘C */}
          </Typography>
        </MenuItem>     
        <MenuItem onClick={props.payout}>
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          <ListItemText>Payout</ListItemText>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {/* ⌘C */}
          </Typography>
        </MenuItem>
        <MenuItem onClick={props.retire}>
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          <ListItemText>Retire</ListItemText>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {/* ⌘C */}
          </Typography>
        </MenuItem> 
        <MenuItem onClick={props.delete}>
          <ListItemIcon>
            <Delete fontSize="small" />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {/* ⌘V */}
          </Typography>
        </MenuItem>
        {/* <Divider />
        <MenuItem>
          <ListItemIcon>
            <Cloud fontSize="small" />
          </ListItemIcon>
          <ListItemText>Web Clipboard</ListItemText>
        </MenuItem> */}
      </MenuList>
    </Paper>
  );
}
